import _get from 'lodash/get';
import { getAnalyticsById } from '../player/player.selectors';

export const getHeartbeatV2 = getAnalyticsById('heartbeat-v2');

export const getHeartbeatV3 = getAnalyticsById('heartbeat-v3');

export const getHeartbeatState = state => _get(state, 'heartbeat');

export const getHeartbeatInterval = state => _get(state, 'heartbeat.heartbeatInterval');

export const isHeartbeatEnabled = state => _get(state, 'heartbeat.enabled');

export const getVideoClipType = state => _get(getHeartbeatV2(state), 'session.clipType', '');

export const getProgramId = state => _get(getHeartbeatV2(state), 'session.programId', '');

export const getServiceCode = state => _get(getHeartbeatV2(state), 'session.serviceCode', '');

export const getHeartbeatSessionId = state => _get(state, 'heartbeat.sessionId');
